import { useState } from "react";
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import CalendarTimePicker from "./CalendarTimePicker";
import CalendarDatePicker from "./CalendarDatePicker";
import moment from "moment";

const EventCancelModal = ({ eventDetails, setShowCancelViewModal }) => {
    const { t } = useTranslation();
    const [showDropDown, setShowDropDown] = useState();
    const [reason, setReason] = useState();

    const handleShowCreateModal = (e) => {
        e.preventDefault();
        setShowCancelViewModal()
    };
    const handleDropDown = (e, data) => {
        e.preventDefault();
        setReason(data);
    };
    const handleDateDataFromChild = (data) => {

    };

    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-end sm:items-center z-50">
            <div className="bg-white rounded-t-lg sm:rounded-lg shadow-lg w-[28rem] p-2.5 sm:p-6 space-y-2 sm:space-y-4">
                <div className="flex justify-between items-center">
                    <div className='flex items-center space-x-2'>
                        <h3 className="text-lg font-semibold capitalize">
                            { t('cancel appointment')}
                        </h3>
                    </div>
                    <button onClick={(e) => handleShowCreateModal(e)} className="text-gray-500 hover:text-gray-700">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>
                </div>
                <div className="space-y-2">
                    <div className="text-sm sm:text-base">
                        {moment(eventDetails.start).format('ddd')} | {moment(eventDetails.start).format('LL')} at {moment(eventDetails.start).format('LT')} - {moment(eventDetails.end).format('LT')}
                    </div>
                    <div className="sm:flex sm:items-center text-sm space-y-1 sm:space-y-0">
                            <div className="sm:border sm:border-y-2 sm:border-l-2 sm:border-background-normal sm:p-2 sm:bg-blue-light capitalize sm:rounded-l-lg sm:w-40 sm:text-center">{ t('reason')}</div>
                            <div className="relative border border-l-2 sm:border-l-0 border-y-2 border-r-2 border-background-normal p-2 w-full rounded-l-lg sm:rounded-l-none rounded-r-lg">
                                <button type="button" onClick={(e) => setShowDropDown(!showDropDown)} className=" text-gray-dark w-full justify-between font-normal inline-flex items-center">
                                    <span className={(reason ? "text-black" : "text-gray-dark") + " capitalize mr-1 text-sm"}>{reason ? reason : t('select reason')}</span>
                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                </button>
                                {
                                    showDropDown
                                    ? 
                                        <ul className="absolute z-30 bg-white shadow-md rounded-md top-10 right-0 w-full">
                                            <li key={`visit${1}`} onClick={(e) => handleDropDown(e, 'data')}  className="bg-white hover:bg-action-hover py-1 sm:py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-sm">list of reason</li>
                                        </ul>                            
                                    : null
                                }
                            </div>
                        </div>
                    <textarea className="bg-white border-2 border-background-normal rounded-md px-4 py-2 w-full relative flex items-start focus:outline-none" rows={3} columns={10} placeholder="write comment here"></textarea>

                </div>
                <div className="flex justify-between items-center text-sm sm:text-base">
                    <button onClick={(e) => handleShowCreateModal(e)} className="px-4 py-2 bg-white text-gray-dark4 capitalize font-medium border-2 border-background-normal rounded-lg">
                        { t('close')}
                    </button>
                    <button className="px-4 py-2 bg-blue-normal text-white rounded-lg capitalize">
                        { t('cancel appointment')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EventCancelModal;
